import React from 'react';
import { Star, ShieldCheck, ExternalLink } from 'lucide-react';
export function SuperhostBadge() {
  return <div className="relative max-w-5xl mx-auto my-12" data-id="element-142">
      <div className="bg-gradient-to-br from-[#FAF7F2] to-white border border-[#D4AF37]/20 rounded-2xl p-8 md:p-12 shadow-xl" data-id="element-143">
        <div className="flex flex-col md:flex-row items-center justify-between gap-8" data-id="element-144">
          {/* Left: Superhost Badge */}
          <div className="flex items-center gap-6" data-id="element-145">
            <div className="relative" data-id="element-146">
              <div className="h-20 w-20 bg-gradient-to-br from-[#FF385C] to-[#BD1E59] rounded-full flex items-center justify-center text-white shadow-2xl" data-id="element-147">
                <ShieldCheck className="h-10 w-10" data-id="element-148" />
              </div>
              <div className="absolute -bottom-2 -right-2 bg-white rounded-full p-1.5 shadow-lg" data-id="element-149">
                <Star className="h-5 w-5 text-[#D4AF37] fill-[#D4AF37]" data-id="element-150" />
              </div>
            </div>
            <div data-id="element-151">
              <h3 className="font-serif text-2xl md:text-3xl font-bold text-[#2C2C2C] mb-1" data-id="element-152">
                Hosted by Superhosts
              </h3>
              <p className="text-[#5C5C5C] text-sm md:text-base" data-id="element-153">
                All properties recognized by Airbnb
              </p>
            </div>
          </div>

          {/* Right: Stats */}
          <div className="flex items-center gap-8" data-id="element-154">
            <div className="text-center" data-id="element-155">
              <div className="text-4xl font-bold text-[#2C2C2C] mb-1" data-id="element-156">
                4.96+
              </div>
              <div className="flex justify-center text-[#D4AF37] mb-1" data-id="element-157">
                {[1, 2, 3, 4, 5].map(i => <Star key={i} className="h-4 w-4 fill-current" data-id="element-158" />)}
              </div>
              <div className="text-xs text-[#5C5C5C]" data-id="element-159">Average Rating</div>
            </div>
            <div className="h-16 w-px bg-[#D4AF37]/20 hidden md:block" data-id="element-160"></div>
            <div className="text-center hidden md:block" data-id="element-161">
              <div className="text-4xl font-bold text-[#2C2C2C] mb-1" data-id="element-162">100+</div>
              <div className="text-xs text-[#5C5C5C] mt-1" data-id="element-163">Happy Guests</div>
            </div>
          </div>
        </div>
      </div>

      {/* Floating Airbnb Link Badge */}
      <a href="https://airbnb.co.in/h/fortkochin" target="_blank" rel="noopener noreferrer" className="absolute -top-4 -right-4 bg-white rounded-full shadow-2xl p-4 hover:scale-110 transition-transform duration-300 border-2 border-[#FF385C] group" data-id="element-164">
        <div className="flex flex-col items-center gap-1" data-id="element-165">
          <div className="flex items-center gap-2" data-id="element-166">
            <svg className="h-6 w-6" viewBox="0 0 24 24" fill="#FF385C" data-id="element-167">
              <path d="M12 0C5.4 0 0 5.4 0 12s5.4 12 12 12 12-5.4 12-12S18.6 0 12 0zm0 22C6.5 22 2 17.5 2 12S6.5 2 12 2s10 4.5 10 10-4.5 10-10 10z" data-id="element-168" />
              <path d="M12 6c-3.3 0-6 2.7-6 6s2.7 6 6 6 6-2.7 6-6-2.7-6-6-6zm0 10c-2.2 0-4-1.8-4-4s1.8-4 4-4 4 1.8 4 4-1.8 4-4 4z" data-id="element-169" />
            </svg>
            <ExternalLink className="h-4 w-4 text-[#FF385C]" data-id="element-170" />
          </div>
          <span className="text-xs font-bold text-[#FF385C] whitespace-nowrap" data-id="element-171">
            View on Airbnb
          </span>
        </div>
      </a>
    </div>;
}